var _clipPath, _clipPath2, _clipPath3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetainline = function SvgMetainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "meta_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.75h16v10.61H0Zm0 0"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "meta_inline_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 2.75h15v10.61H1Zm0 0"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "meta_inline_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.75h5V13H0Zm0 0"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meta_inline_svg__c",
    x1: 13.559,
    x2: 57.559,
    y1: 37,
    y2: 39.222,
    gradientTransform: "scale(.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0064e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#0064e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#0073ee",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0082fb",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "meta_inline_svg__e",
    x1: 10,
    x2: 10,
    y1: 41.889,
    y2: 25.667,
    gradientTransform: "scale(.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0082fb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0064e0",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#meta_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.727 9.746c0 .613.132 1.078.308 1.363.23.371.57.528.918.528.453 0 .863-.11 1.656-1.207.637-.88 1.387-2.114 1.891-2.887l.852-1.313c.593-.91 1.277-1.921 2.066-2.609.64-.558 1.336-.871 2.031-.871 1.172 0 2.285.68 3.14 1.95.934 1.394 1.388 3.148 1.388 4.96 0 1.078-.215 1.867-.575 2.492-.347.606-1.027 1.207-2.172 1.207v-1.722c.977 0 1.223-.899 1.223-1.93 0-1.469-.344-3.098-1.098-4.262-.535-.824-1.226-1.328-1.988-1.328-.824 0-1.488.621-2.234 1.73-.399.59-.805 1.31-1.262 2.122l-.504.89c-1.012 1.793-1.27 2.2-1.773 2.875-.887 1.18-1.645 1.625-2.64 1.625-1.18 0-1.927-.511-2.391-1.28C.188 11.448 0 10.624 0 9.686Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#0081fb",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#meta_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.36 4.82c.792-1.218 1.933-2.07 3.245-2.07.758 0 1.512.223 2.297.867.864.703 1.782 1.86 2.926 3.766l.41.687c.992 1.649 1.555 2.5 1.883 2.899.426.515.723.668 1.11.668.98 0 1.222-.899 1.222-1.93l1.524-.047c0 1.078-.211 1.867-.575 2.492-.347.606-1.027 1.207-2.172 1.207-.71 0-1.34-.152-2.039-.808-.535-.504-1.16-1.403-1.64-2.207L8.117 7.949c-.719-1.199-1.379-2.097-1.762-2.5-.41-.437-.937-.965-1.78-.965-.68 0-1.259.48-1.743 1.211Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#meta_inline_svg__c)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#meta_inline_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.574 4.484c-.68 0-1.261.48-1.746 1.211C2.145 6.73 1.727 8.27 1.727 9.746c0 .613.132 1.078.308 1.363l-1.473.97C.188 11.448 0 10.624 0 9.686c0-1.71.469-3.492 1.36-4.867.792-1.218 1.933-2.07 3.242-2.07Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#meta_inline_svg__e)"
    }
  })));
};
export default SvgMetainline;